import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem('api_token') || ''

export const PROPERTY_USER_API = `${LOCAL_URL}/propertyUser/listPropertyUser`
export const ADD_USER_API = `${LOCAL_URL}/propertyUser/creatPropertyUser`
export const LIST_USER_TYPE = `${LOCAL_URL}/propertyUser/listPropertyUserType`
export const BLOCK_PROPERTY = `${LOCAL_URL}/propertyUser/blockPropertyUser`
export const UNBLOCK_PROPERTY = `${LOCAL_URL}/propertyUser/unblockPropertyUser`
export const GET_USER_DETAILS = `${LOCAL_URL}/propertyUser/listSinglePropertyUser`
export const UPDATE_USER = `${LOCAL_URL}/propertyUser/updateSinglePropertyUser`
export const GET_USERTYPE = `${LOCAL_URL}/propertyUser/check_property_user`

const headers = {
  Authorization: API_TOKEN,
 
}


// API TO GET LIST OF PROPERTY USERS

export async function ListPropertyUser(property_uuid: string, offset:number,
limit:number, search:string) {
  return await axios.post(PROPERTY_USER_API, {
    property_uuid,offset,limit,search
  })
}

//API TO GET ALL USERTYPE

export async function GetUserType() {
    return await axios.get(LIST_USER_TYPE, {
        headers: {...headers},
    })
  }

  //API TO CREATE PROPERTY USER 

export async function createUser(
    owner_name :any,
    owner_email_id :any,
    owner_contact_number: string,
    property_account_type_uuid:string,
    property_uuid :string,
    property_share ?:number,
    rental_share ?:number
   ) {
    return await axios.post(ADD_USER_API, {
        owner_name,
        owner_email_id,
        owner_contact_number,
        property_account_type_uuid,
        property_uuid,
        property_share,
        rental_share
    })
  }

  // API TO BLOCK A PROPERTY USER

export async function blockPropertyUser(property_uuid: string,property_account_uuid:string){
    let data ={
      property_uuid:property_uuid,
      property_account_uuid:property_account_uuid
    }
    console.log("data,data")
    return axios.post(BLOCK_PROPERTY,data,{
      headers: {...headers},
  })
  }
  
  
  // API TO UNBLOCK A PROPERTY USER
  
  export async function unblockPropertyUser(property_uuid: string,property_account_uuid:string){
    let data ={
      property_uuid:property_uuid,
      property_account_uuid:property_account_uuid
    }
    return axios.post(UNBLOCK_PROPERTY,data,{
      headers: {...headers},
  })
  }

//API TO FETCH  PROPERTY USER DETAILS FOR UPDATE


export async function getUserDetails(property_account_uuid:string) {
  return await axios.post(GET_USER_DETAILS, {
     
    property_account_uuid
  })
}

//API to Update PropertyUser
export async function UpdateUser(
  property_account_uuid :string,
  property_account_type_uuid:string, ) {
  return await axios.post(UPDATE_USER, {
     
 
    property_account_uuid ,
    property_account_type_uuid
  })
}

// get person user type

export async function getUserData(property_uuid:string) {
  return await axios.post(GET_USERTYPE, {
     
    property_uuid
  })
}